export default "__VITE_ASSET__hH5D6LhV__"